export function getPatientMeetingLink(appointment, patientId) {
  const currentPatientId = patientId ? String(patientId) : "";
  const primaryPatientId = appointment?.pid ? String(appointment.pid) : "";
  const patientLinks = appointment?.virtualMeeting?.patientLinks || {};

  if (currentPatientId && patientLinks[currentPatientId]) {
    return patientLinks[currentPatientId];
  }

  if (currentPatientId && currentPatientId === primaryPatientId) {
    return appointment?.virtualMeeting?.patientLink || appointment?.patientApptLink || "";
  }

  if (appointment?.patientApptLink) {
    return appointment.patientApptLink;
  }

  if (!currentPatientId) {
    return appointment?.virtualMeeting?.patientLink || "";
  }

  return "";
}
